import { setCookie, getCookie } from '../utils/cookies';

const selectors = {
    banner: '.js-cookie-banner',
    acceptBtn: '.js-cookie-banner-accept',
    rejectBtn: '.js-cookie-banner-reject',
    updateBtn: '.js-cookie-banner-update',
}

const isProd = document.body.dataset.env === 'production';
const GTM_ID = document.body.dataset.gtmId;
const FB_PIXEL_ID = document.body.dataset.fbPixelId;

const loadGTM = () => {
    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer',GTM_ID);
    
    const noscript = document.createElement('noscript');
    const iframe = document.createElement('iframe');
    iframe.src = 'https://www.googletagmanager.com/ns.html?id=' + GTM_ID;
    iframe.height = '0';
    iframe.width = '0';
    iframe.style.display = 'none';
    iframe.style.visibility = 'hidden';
    noscript.appendChild(iframe);
    document.body.insertBefore(noscript, document.body.firstChild);
}

const allowGTM = () => {
    window.dataLayer.push({
        'event': 'update_consent',
        'ad_storage': 'granted',
        'analytics_storage': 'granted',
        'ad_user_data': 'granted',
        'ad_personalization': 'granted'
    });
}

const loadFBPixel = () => {
    !(function(f,b,e,v,n,t,s)
    {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};
    if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
    n.queue=[];t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t,s)})(window, document,'script',
    'https://connect.facebook.net/en_US/fbevents.js');

    window.fbq('init', FB_PIXEL_ID);
    window.fbq('track', 'PageView');
}

const init = () => {
    const banner = document.querySelector(selectors.banner);
    
    if (!banner) return;
    banner.classList.add('is-initialized');

    const acceptBtn = banner.querySelector(selectors.acceptBtn);
    const rejectBtn = banner.querySelector(selectors.rejectBtn);

    const syncShopifyCookies = (consent) => {
        window.Shopify.customerPrivacy.setTrackingConsent({
            'marketing': consent,
            'analytics': consent,
            'preferences': consent,
            'headlessStorefront': true,
            'checkoutRootDomain': banner.dataset.checkoutDomain,
            'storefrontRootDomain': banner.dataset.storefrontDomain,
            'storefrontAccessToken': banner.dataset.storefrontAccessToken
        }).catch(err => {
            console.error('Error updating Shopify cookies:', err.error);
        });
    }

    window.dataLayer = window.dataLayer || [];

    window.dataLayer.push({
        'event': 'default_consent',
        'ad_storage': 'denied',
        'analytics_storage': 'denied',
        'ad_user_data': 'denied',
        'ad_personalization': 'denied'
    });

    loadGTM();


    window.cookieConsent = getCookie('cookies-accepted');

    if (window.cookieConsent) {
        document.dispatchEvent(new Event('cookiesUpdated'));

        syncShopifyCookies(Boolean(window.cookieConsent));
        if (window.cookieConsent === 'true' && isProd) {
            allowGTM();
            loadFBPixel();
        }
        banner.style.display = 'none';
    }

    acceptBtn.addEventListener('click', () => {
        setCookie('cookies-accepted', 'true', 182);
        window.cookieConsent = 'true';
        banner.style.display = 'none';
        syncShopifyCookies(true);
        if (isProd) {
            allowGTM();
            loadFBPixel();
        }
        document.dispatchEvent(new Event('cookiesUpdated'));
    });

    rejectBtn.addEventListener('click', () => {
        setCookie('cookies-accepted', 'false', 182);
        window.cookieConsent = 'false';
        banner.style.display = 'none';
        syncShopifyCookies(false);
        document.dispatchEvent(new Event('cookiesUpdated'));
    });

    const updateBtn = document.querySelector(selectors.updateBtn);
    updateBtn.addEventListener('click', () => {
        banner.style.display = '';
    });
};

const module = () => {
    const script = document.createElement('script');
    script.async = true;
    script.onload = () => {
        init();
    };
    script.src = 'https://cdn.shopify.com/shopifycloud/consent-tracking-api/v0.1/consent-tracking-api.js';
    document.head.appendChild(script);
};

export default module;